var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"expandable-column",attrs:{"colspan":_vm.$parent.columnLength}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }